import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Demo from './components/Demo';
import GettingStarted from './components/GettingStarted';
import Features from './components/Features';
import DataProtection from './components/DataProtection';
import RevenueImpact from './components/RevenueImpact';
import About from './components/About';
import CTA from './components/CTA';
import Footer from './components/Footer';
import SignIn from './components/SignIn';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';

// Home page component
const HomePage = () => (
  <>
    <Hero />
    <Demo />
    <GettingStarted />
    <Features />
    <DataProtection />
    <RevenueImpact />
    <About />
    <CTA />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
